//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

enum MediaType {
  Image = 'image',
  Unknown = 'unknown',
  Video = 'video',
}

export default MediaType;
